module.exports = __webpack_public_path__ + "img/caidaoApp-4.04cde2bb.png";